// extracted by mini-css-extract-plugin
export default {"wrapper":"Promotion_wrapper__mzel2","header":"Promotion_header__c8r2a","image":"Promotion_image__CyK0E","link":"Promotion_link__nYuh1","content":"Promotion_content__sI-cj"};